import { render } from "./Guestpage.vue?vue&type=template&id=52cfcea6&scoped=true"
import script from "./Guestpage.vue?vue&type=script&lang=js"
export * from "./Guestpage.vue?vue&type=script&lang=js"

import "./Guestpage.vue?vue&type=style&index=0&id=52cfcea6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Jerald Pamugas\\OneDrive\\Desktop\\Projects\\jerald-pamugas-1\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cfcea6"]])

export default __exports__